import React, { Component } from 'react';

class HcpSunset extends Component {
  render() {
    return (
      <div className='notice-box'>
        <h1>Notice</h1>
        <p>
          The <strong>Taiho Oncology Patient Support HCP Portal</strong> is no longer available.
        </p>
        <p className='highlight-Text'>
          <strong>Please direct all communications to:</strong>
        </p>
        <p>
          <strong>Taiho Oncology Patient Support</strong>
        </p>
        <p>
          <strong>Fax:</strong> 1-844-287-2559
        </p>
        <p>
          If you have any questions, please call: <strong>1-844-824-4648</strong>
        </p>
      </div>
    );
  }
}

export default HcpSunset;
